import { Injectable } from '@angular/core';
import { Message, MessageService } from 'primeng/api';

@Injectable()
export class NotificationService {
    message?: Message[];

    constructor(
        private messageService: MessageService
    ) {}

    success(summary: any, detail: any) {
        this.messageService.add(
            {
                severity: 'success',
                summary: summary,
                detail: detail
            });
    }

    warning(summary: any, detail: any) {
        this.messageService.add(
            {
                severity: 'warn',
                summary: summary,
                detail: detail
            });
    }

    error(summary: any, detail: any) {
        this.messageService.add(
            {
                severity: 'error',
                summary: summary,
                detail: detail
            });
    }

}
